import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, normalizeClass, createCommentVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const SIZES = { sm: "h-7 px-4 text-xs", md: "h-9 px-5 text-sm", lg: "h-11 px-7 text-base" };
const ACTIVE_CLASS = "text-p-purple-60";
const getOffsetValues = (container) => {
  const el = container.cloneNode(true);
  el.style.visibility = "hidden";
  document.body.appendChild(el);
  const activeBtn = el.querySelector(`button.${ACTIVE_CLASS}`);
  const res = { width: `${activeBtn.offsetWidth}px`, left: `${activeBtn.offsetLeft}px` };
  document.body.removeChild(el);
  return res;
};
const _sfc_main = defineComponent({
  name: "PSelectPill",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemSubtext: {
      type: String,
      default: "subtext"
    },
    itemValue: {
      type: [String, Number],
      default: "value"
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return Object.keys(SIZES).includes(value);
      }
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      SIZES,
      ACTIVE_CLASS
    };
  },
  watch: {
    modelValue: {
      handler() {
        setTimeout(() => this.setPillStyle(), 60);
      },
      immediate: true,
      flush: "post"
    },
    items: {
      handler() {
        setTimeout(() => this.setPillStyle(), 60);
      },
      immediate: true,
      flush: "post",
      deep: true
    }
  },
  methods: {
    click(e, option) {
      if (!option.disabled) {
        this.$emit("update:modelValue", option[this.itemValue]);
      }
    },
    setPillStyle() {
      const el = this.$el.querySelector(`button.${ACTIVE_CLASS}`);
      if (!el) {
        return;
      }
      const dimensions = el.offsetWidth !== 0 ? { left: `${el.offsetLeft}px`, width: `${el.offsetWidth}px` } : getOffsetValues(this.$el);
      if (this.$refs.pill && this.$refs.pill instanceof HTMLElement) {
        this.$refs.pill.style.left = dimensions.left;
        this.$refs.pill.style.width = dimensions.width;
      }
    }
  }
});
const _hoisted_1 = { class: "relative inline-flex rounded-full border-2 border-p-gray-30 bg-p-gray-30 text-center font-semibold text-p-gray-50" };
const _hoisted_2 = {
  ref: "pill",
  class: "absolute left-0 top-0 inline-block h-full rounded-full bg-surface duration-200 ease-in-out"
};
const _hoisted_3 = ["disabled", "data-selected", "onClick"];
const _hoisted_4 = { class: "flex" };
const _hoisted_5 = {
  key: 0,
  class: "pl-1 opacity-50"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, null, 512),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (o) => {
      return openBlock(), createElementBlock("button", {
        key: o[_ctx.itemValue],
        disabled: o.disabled,
        class: normalizeClass(["z-10 duration-700", [
          _ctx.SIZES[_ctx.size],
          _ctx.modelValue === o[_ctx.itemValue] ? `${_ctx.ACTIVE_CLASS} hover:text-p-purple-70` : "hover:text-p-gray-60",
          { "opacity-25": o.disabled }
        ]]),
        "data-selected": _ctx.modelValue === o[_ctx.itemValue],
        onClick: ($event) => _ctx.click($event, o)
      }, [
        createElementVNode("div", _hoisted_4, [
          createElementVNode("div", null, toDisplayString(o[_ctx.itemText]), 1),
          o[_ctx.itemSubtext] ? (openBlock(), createElementBlock("div", _hoisted_5, toDisplayString(o[_ctx.itemSubtext]), 1)) : createCommentVNode("", true)
        ])
      ], 10, _hoisted_3);
    }), 128))
  ]);
}
const pSelectPill = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  pSelectPill as default
};
